import { render } from "./TheDashboardLayout.vue?vue&type=template&id=22f30b9e&scoped=true"
import script from "./TheDashboardLayout.vue?vue&type=script&lang=js"
export * from "./TheDashboardLayout.vue?vue&type=script&lang=js"

import "./TheDashboardLayout.vue?vue&type=style&index=0&id=22f30b9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f30b9e"]])

export default __exports__